import React, { useState, useMemo } from 'react';
import style from './scoring-item-style.module.scss';
import useIsLandscape from '../../../javascript/utils/use-is-landscape.js';
// import { TENNIS_SCORE_NAMES } from '../../../javascript/services/consts';

function ScoringItem({ pos, settings, callback }) {
   const isLandscape = useIsLandscape();
   const [score, setScore] = useState(() => 0);
   const [preScore, setPreScore] = useState(() => '');
   const [preStyle, SetPreStyle] = useState(() => {});
   const [mainScoreVisible, setMainScoreVisible] = useState(() => true);


   var extraClass = '';
   if (pos === 'left') { extraClass = style.scoreItemLeft; } 
   else if (pos === 'right') { extraClass = style.scoreItemRight; }

   const updateScore = (settings) => {

      if (typeof settings !== 'undefined') {
         if (typeof settings.score !== 'undefined') {
            // console.log('DEBUG - ScoringItem - updateScore - score: ', settings.score);
            setScore(settings.score);
         }
         if (typeof settings.pre !== 'undefined') {
            // console.log('DEBUG - ScoringItem - updateScore - pre: ', settings.pre);
            setPreScore(settings.pre);
         }
         if (typeof settings.pre_color !== 'undefined') {
            SetPreStyle({ color: settings.pre_color });
         }
         if (typeof settings.mainScoreVisible !== 'undefined') {
            // console.log('DEBUG - ScoringItem - updateScore - mainScoreVisible: ', settings.mainScoreVisible);
            setMainScoreVisible(settings.mainScoreVisible);
         }
      }
   }

   useMemo(() => {
      return updateScore(settings)
   }, [settings])

   const scoreClick = () => {
      if (typeof callback === 'function') {
         callback({ pos });
      }
   }
   
   return (
      <div
         onClick={scoreClick}
         className={`${isLandscape ? style.scoreItem : style.scoreItemPortrait} ${extraClass} ${preScore !== null ? style.scoreItemSmall : ''}`}
      >
 
         {mainScoreVisible ? (<span> {score} </span>): <></>}
         <span className={`${style.preScore}`} style={preStyle}>{preScore}</span>
      </div>
   );
}

export default ScoringItem;

